import { render } from "./BottomNavDropdownItem.vue?vue&type=template&id=e34cc594"
import script from "./BottomNavDropdownItem.vue?vue&type=script&lang=js"
export * from "./BottomNavDropdownItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__